'use strict';

const CONST = require('plugin_frontend_core/constants');

const selectors = {
    addressForm: '.js-address-form',
    countrySelect: '.js-address-country',
    suiteField: '.js-address-suite',
    suiteAdditionField: '.js-address-suiteAddition',
    zipCodeField: '.js-address-zipcode',
    city: '.js-address-city',
    address1: '.js-address-address1',
    postCodeError: '.js-address-error',
    suiteError: '.js-address-suite-error',
    suiteAdditionError: '.js-address-suiteAddition-error',
    addressError: '.js-address-addressName-error',
    cityError: '.js-address-city-error',
    submitButton: '.js-address-form-button'
};

const classes = {
    dBlock: CONST.classes.dBlock,
    isInvalid: CONST.classes.invalid
};

/**
 * Retrieves the submit button for the scope of the current address form.
 * If the submit button was not found, the function tries to get it from the scope of the first parent element.
 *
 * @param {jQuery} $form - The instance that represents the scope of the current address form.
 * @returns {jQuery} - The submit button.
 */
function getSubmitButton($form) {
    let $submitButton = $form.find(selectors.submitButton);

    if (!$submitButton.length) {
        $form.parents().each(function (i, parent) {
            $submitButton = $(parent).find(selectors.submitButton);

            return !$submitButton.length;
        });
    }

    return $submitButton;
}

/**
 * Blocks address fields based on the selected country.
 *
 * @param {jQuery} $form - The instance that represents the scope of the current address form.
 * @param {string} selectedCountry - The selected country in the scope of the current address form.
 */
function blockAddressFields($form, selectedCountry) {
    const addressFields = [
        {
            element: $form.find(selectors.address1),
            blocked: ['NL']
        },
        {
            element: $form.find(selectors.city),
            blocked: ['NL', 'BE']
        }
    ];

    addressFields.forEach(function (field) {
        field.element.attr('readonly', field.blocked.includes(selectedCountry));
        field.element.toggleClass('disabled', field.blocked.includes(selectedCountry));
    });
}

/**
 * Clears all address fields.
 *
 * @param {jQuery} $form - The instance that represents the scope of the current address form.
 */
function clearAddressFields($form) {
    const addressFields = [
        $form.find(selectors.zipCodeField),
        $form.find(selectors.suiteField),
        $form.find(selectors.suiteAdditionField),
        $form.find(selectors.address1),
        $form.find(selectors.city)
    ];

    addressFields.forEach(function (field) {
        field.val('');
    });
}

/**
 * Populates information for address fields based on the result from the Autocomplete call.
 *
 * @param {jQuery} $form - The instance that represents the scope of the current address form.
 * @param {Object} result - The result object from the Autocomplete call.
 */
function populateAddressFields($form, result) {
    const selectedCountry = $form.find(selectors.countrySelect).val();

    const addressFields = [
        {
            element: $form.find(selectors.address1),
            populated: ['NL'],
            key: 'street'
        },
        {
            element: $form.find(selectors.city),
            populated: ['NL', 'BE'],
            key: 'city'
        }
    ];

    addressFields.forEach(function (field) {
        if (field.populated.includes(selectedCountry)) {
            field.element.val(result[field.key] || '');
        }
    });
}

/**
 * Hides all available errors for address fields.
 *
 * @param {jQuery} $form - The instance that represents the scope of the current address form.
 */
function hideErrorsAddressFields($form) {
    const addressFields = [
        {
            element: $form.find(selectors.zipCodeField),
            error: $form.find(selectors.postCodeError)
        },
        {
            element: $form.find(selectors.suiteField),
            error: $form.find(selectors.suiteError)
        },
        {
            element: $form.find(selectors.suiteAdditionField),
            error: $form.find(selectors.suiteAdditionError)
        },
        {
            element: $form.find(selectors.address1),
            error: $form.find(selectors.addressError)
        },
        {
            element: $form.find(selectors.city),
            error: $form.find(selectors.cityError)
        }
    ];

    addressFields.forEach(function (field) {
        field.element.removeClass(classes.isInvalid);
        field.error.removeClass(classes.dBlock);
    });

    const $submitButton = getSubmitButton($form);

    $submitButton.attr('disabled', false);
}

/**
 * Handles the change event for the country selector.
 *
 * @param {Event} e - The change event.
 * @param {boolean} skipСleaning - Identifies whether cleaning of the address fields should be skipped.
 */
function onChangeCountrySelect(e, skipСleaning = true) {
    const $form = $(e.target).closest(selectors.addressForm);

    hideErrorsAddressFields($form);
    // TODO: clear template from "enabled/disabled" classes during initial page load
    blockAddressFields($form, e.target.value);

    if (!skipСleaning) {
        clearAddressFields($form);
    }
}

/**
 * Shows all available errors for address fields based on the result from the Autocomplete call.
 *
 * @param {jQuery} $form - The instance that represents the scope of the current address form.
 * @param {Object} result - The result object from the Autocomplete call.
 */
function showErrorsAddressFields($form, result) {
    const errorsMap = {
        postalCode: {
            element: $form.find(selectors.postCodeError),
            replace: true
        },
        suite: {
            element: $form.find(selectors.suiteError),
            replace: false
        },
        extension: {
            element: $form.find(selectors.suiteAdditionError),
            replace: false
        },
        address: {
            element: $form.find(selectors.addressError),
            replace: false
        },
        city: {
            element: $form.find(selectors.cityError),
            replace: false
        },
        addressUnknown: {
            element: $form.find(selectors.postCodeError),
            replace: true
        }
    };

    Object.keys(result).forEach(function (key) {
        if (errorsMap[key]) {
            errorsMap[key].element.addClass(classes.dBlock);

            if (errorsMap[key].replace) {
                errorsMap[key].element.text(result[key]);
            }

            if (!$form.is(':visible')) {
                window.pubSub.publish(CONST.pubSubEvents.showNotification, {
                    msg: errorsMap[key].replace ? result[key] : errorsMap[key].element.text(),
                    result: 'error'
                });
            }
        }
    });

    const $submitButton = getSubmitButton($form);

    $submitButton.attr('disabled', true);
}

/**
 * Handles the Autocomplete call result and processes it.
 * The result can be either successful or with some errors.
 *
 * @param {Object} result - The result object from the Autocomplete call.
 * @param {jQuery} $form - The instance that represents the scope of the current address form.
 */
function handleAutocompleteResult(result, $form) {
    hideErrorsAddressFields($form);

    if (result.status === 'ok') {
        populateAddressFields($form, result);
    } else {
        populateAddressFields($form, {});
        showErrorsAddressFields($form, result);
    }
}

/**
 * The main function which searches for address forms on the page and applies the Autocomplete functionality.
 * Also, it binds the custom logic for handling country selection and results from the Autocomplete call.
 */
(function () {
    $(selectors.countrySelect).on(CONST.events.change, onChangeCountrySelect);

    if ($.fn.applyAutocomplete) {
        $(document).ready(function () {
            $(selectors.addressForm).each(function (i, addressForm) {
                $(addressForm).applyAutocomplete(handleAutocompleteResult);
            });
        });
    }

    if ($.fn.applySuggestStreet) {
        $(document).ready(function () {
            $(selectors.addressForm).each(function (i, addressForm) {
                $(addressForm).applySuggestStreet();
            });
        });
    }

    // initializing each address form available on the page
    $(document).ready(function () {
        $(selectors.addressForm).each(function (i, addressForm) {
            $(addressForm).find(selectors.countrySelect).trigger(CONST.events.change, true);
        });
    });
}());
